@for (project of projects.items; track project) {
  <shared-master-project-image-panel [project]="project" [size]="400">
  </shared-master-project-image-panel>
}
